module.exports = __webpack_public_path__ + "img/rksp.dc45ec85.png";